@if (state$ | async; as state) {
  <div class="page-header">
    <div class="page-title">Zamówienia</div>

    <div class="header-toolbar">
      <input class="search-input" type="text" placeholder="Szukaj…" #search
        (input)="onSearchInput(search.value)">

      <button class="btn" #statusFilterTrigger>Status: {{ state.statusFilter !== undefined ? statusLabels[state.statusFilter] : 'Wszystkie' }}</button>

      <a class="btn" [routerLink]="['/client-orders', 'new']">+ Nowe zamówienie</a>
    </div>
  </div>

  <dropdown [searchFunc]="searchStatusOptions" [searchFormatter]="formatStatusOption" [trigger]="statusFilterTrigger"
    [minSearchLength]="0" [debounceMs]="0" header="STATUS" (itemSelected)="onStatusSelected($event)"></dropdown>

  <!-- the count line and the table with its header row are the layout; the rows and the count are
       the data, drawn as shadows until it lands (0128) -->
  <div class="list-count">
    @if (state.loading) {
      <span class="shadow"></span>
    } @else if (state.orders) {
      {{ state.orders.length }} zam.
    }
  </div>

  <div class="list-table">
    <div class="list-row list-row-header order-row">
      <div class="list-cell"></div>
      <div class="list-cell">Numer</div>
      <div class="list-cell">Klient</div>
      <div class="list-cell">Nazwa</div>
      <div class="list-cell">Termin</div>
      <div class="list-cell">Status</div>
      <div class="list-cell list-cell-right">W zleceniach</div>
      <div class="list-cell list-cell-right">Wysłane</div>
    </div>

    @if (state.loading) {
      <!-- five rows of the page's own row, at its height: the 28px photo slot holds it (0128) -->
      @for (row of shadowRows; track row) {
        <div class="list-row list-row-shadow order-row">
          <div class="shadow shadow-photo"></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow shadow-long"></span></div>
          <div class="list-cell"><span class="shadow"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell"><span class="shadow shadow-short"></span></div>
          <div class="list-cell list-cell-right"><span class="shadow shadow-short"></span></div>
          <div class="list-cell list-cell-right"><span class="shadow shadow-short"></span></div>
        </div>
      }
    } @else if (state.orders) {
      @for (order of state.orders; track order.id) {
        <a class="list-row order-row" [class.overdue]="order.overdue" [routerLink]="['/client-orders', order.id]">
          <order-face [photos]="order.photos"></order-face>
          <div class="list-cell order-row-number text-mono">{{ order.orderNumber }}</div>
          <div class="list-cell order-row-client" [title]="order.clientName">{{ order.clientName }}</div>
          <div class="list-cell order-row-name" [title]="order.name ?? ''">{{ order.name ?? '' }}</div>
          <div class="list-cell order-row-deadline text-mono">
            @if (order.overdue) {
              <!-- the planner's deadline flag — past the promise and not shipped -->
              <svg class="overdue-flag" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <title>Po terminie, nie wysłane</title>
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 16.5v-4.875" />
              </svg>
            }
            {{ order.deadlineLabel ?? '—' }}
          </div>
          <div class="list-cell order-row-status">{{ order.statusLabel }}</div>
          <div class="list-cell list-cell-right order-row-coverage text-mono">{{ order.allocatedLabel }}</div>
          <div class="list-cell list-cell-right order-row-coverage text-mono">{{ order.shippedLabel }}</div>
        </a>
      } @empty {
        @if (state.search || state.statusFilter !== undefined) {
          <div class="list-empty">Brak zamówień spełniających kryteria.</div>
        } @else {
          <div class="list-empty">Brak zamówień — zacznij od dodania nowego zamówienia.</div>
        }
      }
    }
  </div>
}
